export default __webpack_public_path__ + "static/media/Consultor03Exclusivo.f62613ad.png";